module.exports = __webpack_public_path__ + "img/UTFHNH-6.d2af7ba1.jpg";